<script setup lang="ts">

</script>

<template>
  <router-view />
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  color: #2c3e50;
}

.maxWidthPx {
  max-width: 430px;
  margin: 0 auto;
}
</style>
